/**
 * @file Newsletter.
 */

/**
 * Newsletter component.
 */
const vNewsletter = () => {
	const newsletter = document.querySelector('.v-newsletter');

	if (!newsletter) {
		return;
	}

	const wpcf7  = newsletter.querySelector('.wpcf7');

	if (wpcf7) {
		const email  = newsletter.querySelector('.v-footer__newsletter-input');
		const success = newsletter.querySelector('.v-newsletter__success');
		const observer = new MutationObserver((mutations) => {
			[...mutations].forEach((mutation) => {
				if (mutation.type === 'attributes'
					&& mutation.attributeName === 'class'
					&& mutation.target.classList.contains('wpcf7-not-valid')) {
					wpcf7.classList.add('input-invalid');
				} else if (
					mutation.type === 'attributes'
					&& mutation.attributeName === 'class'
					&& !mutation.target.classList.contains('wpcf7-not-valid')
				) {
					wpcf7.classList.remove('input-invalid');
				}
			});
		});

		/**
		 * Add class to newsletter when input is active.
		 */
		const active = () => {
			wpcf7.classList.add('input-active');
		};

		email.addEventListener('focus', active);
		email.addEventListener('input', active);

		email.addEventListener('blur', () => {
			wpcf7.classList.remove('input-active');
		});

		wpcf7.addEventListener('wpcf7mailsent', () => {
			wpcf7.classList.remove('input-active');
		});

		wpcf7.addEventListener('wpcf7invalid', () => {
			wpcf7.classList.remove('input-active');
			wpcf7.classList.add('input-invalid');
		});

		observer.observe(email, { attributes: true });

		wpcf7.addEventListener('wpcf7submit', () => {
			wpcf7.classList.add('hidden');
			success.classList.remove('hidden');
		});
	}
};

export default vNewsletter;
